import { useContext, useEffect, useState } from 'react';
import LoginContext from '../../../../../store/login-context';

import BackLink from '../../../../General/Static/BackLink/BackLink';
import classes from './PreLogin.module.scss';
import account from '../../../../../assets/img/account.png';
import Login from '../../Login';

declare function Translate(key: string): string;

const PreLogin = (props) => {

    const ctx = useContext(LoginContext);
    
    const [descArr, setDescArr] = useState<string[]>([]);
    
    useEffect(() => {
        var descStr = Translate('N_Login_Account_Link_Desc');
        setDescArr(descStr.split(','));
    },[]);

     

    const onBackHandler = () => {
        props.Cancel();
    }

    const handleContinueClick = () => {  
        props.Continue();        
      };
  
    const handleContinuePress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            handleContinueClick();
        }        
    };

    const cancelHandler = () => {
        props.Cancel();
    };

    const handleCancelPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            cancelHandler();
        }        
    };


    return (        
        <>                  
            <div className={classes.container}>
           
            <BackLink back={onBackHandler} loginType="" translate={Translate('N_General_Back_To_Previous_Page')}/>
            
            <div className={classes.main}>
                <div className={classes.img_wrapper}>
                    <img src={account} alt="" aria-hidden="true"/>
                </div>

                <div className={classes.desc}>
                    <div>{descArr[0]},</div>
                    <div>{descArr[1]}</div>
                </div>

                <div className={classes.button_container}>
                    <button 
                        id='btnLoginAccount'
                        className={classes.button}
                        onClick={handleContinueClick}
                        onKeyPress={handleContinuePress}
                        tabIndex={0}
                    >                         
                        {Translate('N_General_Forward_To_Login')}  
                    </button>                       
                </div>

                <div 
                    className={classes.cancel_link} 
                    id="cancelPreLogin" 
                    role="link" 
                    tabIndex={0} 
                    onClick={cancelHandler}
                    onKeyPress={handleCancelPress}
                >
                    <span>{Translate('N_General_cancel_butten')}</span>                         
                </div>    
           
            </div>
            </div>
        </>  
                
    );
};
export default PreLogin;